/**
 * The tactics themes, in teaching order (docs/SCHAAK.md §3.1). `key` is the
 * Lichess puzzle-database theme tag the pack was built from; the label and the
 * one-screen intro are what Jurren reads. A theme unlocks the next one once
 * THEME_MASTERY of its puzzles have been solved at the first try.
 */
export const SCHAAK_THEMES = [
    {
        key: 'mateIn1',
        label: 'Mat in één',
        intro: 'Eén zet en het is uit. Elke partij kan zo eindigen — voor jou of voor de ander.',
        look: 'Welke schaakjes heb ik? Kan de koning na elk ervan nog ergens heen?',
    },
    {
        key: 'hangingPiece',
        label: 'Hangend stuk',
        intro: 'Een stuk dat niemand verdedigt, kun je gratis slaan. Op dit niveau beslist dit de meeste partijen.',
        look: 'Wat staat er onverdedigd? Wat valt de laatste zet van de ander aan — en wat liet hij los?',
    },
    {
        key: 'fork',
        label: 'Vork',
        intro: 'Eén stuk valt er twee tegelijk aan. De ander kan er maar één redden.',
        look: 'Kan één stuk van mij twee dingen tegelijk aanvallen? Het paard is hier de kampioen.',
    },
    {
        key: 'pin',
        label: 'Penning',
        intro: 'Een stuk kan niet weg, omdat er iets waardevollers achter staat. Een gepend stuk is een zwak stuk.',
        look: 'Staan twee stukken van de ander op één lijn met hun koning of dame?',
    },
    {
        key: 'skewer',
        label: 'Spies',
        intro: 'Een omgekeerde penning: het waardevolle stuk vóór moet weg, en wat erachter staat valt.',
        look: 'Staat de koning of dame vóór een ander stuk, op een lijn die ik kan aanvallen?',
    },
    {
        key: 'discoveredAttack',
        label: 'Aftrekaanval',
        intro: 'Je zet één stuk opzij en het stuk erachter valt ineens aan. Twee dreigingen in één zet.',
        look: 'Staat er een stuk van mij in de weg van mijn eigen loper, toren of dame?',
    },
    {
        key: 'backRankMate',
        label: 'Mat achter de pionnen',
        intro: 'De koning zit opgesloten achter zijn eigen pionnen. Eén toren of dame op de onderste rij is mat.',
        look: 'Kan de koning van de ander van de onderste rij af? Zo niet: wie bewaakt die rij?',
    },
    {
        key: 'mateIn2',
        label: 'Mat in twee',
        intro: 'Eerst een zet die de koning dwingt, dan het mat. Begin altijd bij de schaakjes.',
        look: 'Welke schaakjes laten de ander maar één antwoord over?',
    },
    {
        key: 'trappedPiece',
        label: 'Gevangen stuk',
        intro: 'Een stuk zonder veilig veld kun je aanvallen tot het valt.',
        look: 'Heeft dat stuk nog een veld om naartoe te vluchten?',
    },
    {
        key: 'doubleCheck',
        label: 'Dubbelschaak',
        intro: 'Twee stukken geven tegelijk schaak. Ertussen zetten of slaan helpt niet — de koning moet lopen.',
        look: 'Kan een aftrekschaak óók zelf schaak geven?',
    },
    {
        key: 'promotion',
        label: 'Promotie',
        intro: 'Een pion die de overkant haalt, wordt een dame. Soms is het hele plan: doorlopen.',
        look: 'Wat houdt mijn pion nog tegen — en kan ik dat wegslaan of weglokken?',
    },
];
export const THEME_KEYS = SCHAAK_THEMES.map((t) => t.key);
/** First-try solves of a theme that unlock the next one. */
export const THEME_MASTERY = 15;
export const themeOf = (key) => SCHAAK_THEMES.find((t) => t.key === key);
/** What a mistake from his own games was, in words (docs/SCHAAK.md §3.2). */
export const MISTAKE_LABELS = {
    missed_mate: { label: 'Mat gemist', plural: 'gemiste matten' },
    allowed_mate: { label: 'Mat toegelaten', plural: 'toegelaten matten' },
    hung: { label: 'Stuk weggegeven', plural: 'weggegeven stukken' },
    missed_capture: { label: 'Winst laten liggen', plural: 'gemiste winsten' },
    other: { label: 'Positie weggegeven', plural: 'andere fouten' },
};
//# sourceMappingURL=themes.js.map